import { createSlice } from "@reduxjs/toolkit"

type AuthUser = {
  name?: string
  email?: string
  picture?: string
  sub?: string
}

type AuthState = {
  isAuthenticated: boolean
  isLoading: boolean
  user: AuthUser | null
  accessToken: string | null
}

const initialState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  user: null,
  accessToken: null,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthState: (state, action) => {
      const nextUser = action.payload?.user || null
      if (nextUser?.sub !== state.user?.sub) state.accessToken = null
      state.isAuthenticated = Boolean(action.payload?.isAuthenticated)
      state.isLoading = Boolean(action.payload?.isLoading)
      state.user = nextUser
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload ? String(action.payload) : null
    },
    clearAccessToken: (state) => {
      state.accessToken = null
    },
    clearAuthState: (state) => {
      state.isAuthenticated = false
      state.isLoading = false
      state.user = null
      state.accessToken = null
    },
  },
})

export const { setAuthState, setAccessToken, clearAccessToken, clearAuthState } = authSlice.actions
export default authSlice.reducer
